import { render } from "./NetworkPanel.vue?vue&type=template&id=72e7ebe9"
import script from "./NetworkPanel.vue?vue&type=script&lang=js"
export * from "./NetworkPanel.vue?vue&type=script&lang=js"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__